import React from 'react';
import { LoadingSpinnerIcon } from '../icons/TourIcons';
import styles from '../stylesheets/tourOnboarding.module.scss';

const LoadingStep = () => {
  return (
    <div className={styles.loadingContent}>
      <div className={styles.spinner} aria-hidden="true">
        <LoadingSpinnerIcon />
      </div>
      <h1 className={styles.title}>Setting up your product tour...</h1>
      <p className={styles.bodyText}>This takes about 3 seconds.</p>
      <p className={styles.bodyTextMuted}>
        Creating sample properties, tenants, and invoices.
      </p>
    </div>
  );
};

export default LoadingStep;
